import styled from 'styled-components';

export const PlayoffInfoSectionWrapper = styled.div`
    width: 100%;
    background-color: ${({ theme }) => theme.Surface.primary};
    margin: 16px 0;
`;
